/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { CheckboxComponent } from '../../../NDC/component/NDCDetails/CMSDrug/CMSDrugInputContainer';
import { setToggleDisputeResolution } from '../../store/action';

const DisputeResolutionCheckbox = ({
  selectedClaimFilter,
  specialConditionExists = false,
  setSuccessMessages
}) => {
  const dispatch = useDispatch();
  const disputeResolution = useSelector(
    (state) => state.sharedState.claim.disputeResolutionToggle
  );
  return (
    <div className={`col-${specialConditionExists ? '3' : '4'} mt-4`}>
      <fieldset className="custom-fieldset">
        <div className="p-0 mt-3 row">
          <div className="mui-custom-form col-12 m-0 d-flex customCheckbox flex-wrap align-items-center">
            <div
              style={{ flex: 1 }}
              className="d-flex justify-content-around align-items-center"
            >
              <div className="text-blue sub-radio no-margin">
                <CheckboxComponent
                  label="Units Changed for Dispute Resolution:"
                  checked={disputeResolution}
                  labelPlacement="start"
                  disabled={false}
                  onChange={() => {
                    setSuccessMessages([]);
                    dispatch(setToggleDisputeResolution(!disputeResolution));
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
    // <div className='col-3 mt-4'>
    //   <fieldset className='custom-fieldset'>
    //     <div className='p-0 mt-0 h-100 d-flex align-items-center justify-content-center'>
    //       Units Changed for Dispute Resolution: <checkbox />
    //       {/* <span style={{ color: "red", fontWeight: 800 }}>
    //         Special Condition Exist
    //       </span> */}
    //     </div>
    //   </fieldset>
    // </div>
  );
};

export default DisputeResolutionCheckbox;
